import { TimelineMax, TweenMax } from 'gsap'; // eslint-disable-line
import matchMediaDesktop from '../../../../utils/client_util';

export default class LogoAnimation {
  constructor(handleExpandSapSurveyTracking, handleCloseSapSurveyTracking) {
    this.handleExpandSapSurveyTracking = handleExpandSapSurveyTracking;
    this.handleCloseSapSurveyTracking = handleCloseSapSurveyTracking;

    this.dom = {
      main: document.querySelector('section.main'),
      svg: document.querySelector('.js-fc-logo'),
      bar: document.querySelector('.js-sap-bar'),
      pageHeader: document.querySelector('.page-header'),
      survey: document.querySelector('.js-sap-survey'),
      closeSurvey: document.querySelector('.js-close-survey'),
      letterGroup: document.querySelector('.js-fc-letter-group'),
      container: document.querySelector('.nav__main-items'),
      sapMask: document.querySelector('.js-fc-sap-mask rect'),
      sapLogo: document.querySelector('#sap-logo'),
      navExtras: document.querySelector(
        '.nav__extras.nav__extras--right > .nav__extras-item'
      )
    };

    // Duration for animation chunks - not total duration
    this.duration = 1;
    this.t = new TimelineMax({
      onStart: this.onStart.bind(this),
      onComplete: this.onComplete.bind(this)
    }).pause();

    this.timeStamps = {
      explode1: 0.3,
      implode1: 1.6,

      explode2: 3.6,
      implode2: 4.6,

      sapReveal: 1.3,
      sapHide: 3.3
    };

    this.scrollStart = window.scrollY;
    this.lastScrollPos = false;
    this.scrollProgress = 0;
    this.maxScroll = document.body.clientHeight * 0.7;
    this.ticking = false;
    this.hasBar = false;
    this.hasSurveyPanel = false;
    this.hasStarted = false;
    this.hasCompleted = false;
    this.hasTimedOut = false;
    this.letterCount = 10;
    this.containerPadding = window.innerWidth > 768 ? 250 : 0;
    this.svgScale = window.innerWidth > 768 ? 1 : 2.5;
    this.scale = 2750 / this.dom.svg.clientWidth;
    this.explodedWidth =
      this.dom.container.clientWidth -
      this.dom.letterGroup.getBBox().width / this.scale / this.svgScale -
      this.containerPadding;
    this.explodedStep = this.explodedWidth / this.letterCount * this.scale;

    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    this.letters = {
      f: {
        path: document.querySelector('#fc-logo-letter-f')
      },
      a1: {
        path: document.querySelector('#fc-logo-letter-a1')
      },
      s: {
        path: document.querySelector('#fc-logo-letter-s')
      },
      t: {
        path: document.querySelector('#fc-logo-letter-t')
      },
      c: {
        path: document.querySelector('#fc-logo-letter-c')
      },
      o: {
        path: document.querySelector('#fc-logo-letter-o')
      },
      m: {
        path: document.querySelector('#fc-logo-letter-m')
      },
      p: {
        path: document.querySelector('#fc-logo-letter-p')
      },
      a2: {
        path: document.querySelector('#fc-logo-letter-a2')
      },
      n: {
        path: document.querySelector('#fc-logo-letter-n')
      },
      y: {
        path: document.querySelector('#fc-logo-letter-y')
      }
    };

    // prepare letter objects
    this.prepareLetters();
    this.prepareDom();
    this.createSapAnimation();
    this.addListeners();
    this.timeChecks();
  }

  /**
   * Add event listeners
   */
  addListeners() {
    // Create a bound instances of the callback methods so we can easily detatch the events later
    this.scrollHandler = this.scrollHandler.bind(this);
    this.startHandler = this.startHandler.bind(this);
    this.enableBar = this.enableBar.bind(this);
    this.enableSurveyPanel = this.enableSurveyPanel.bind(this);
    this.disableSurveyPanel = this.disableSurveyPanel.bind(this);
    this.svgMouseenterHandler = this.svgMouseenterHandler.bind(this);

    window.addEventListener('scroll', this.scrollHandler);
    window.addEventListener('scroll', this.startHandler);

    this.dom.svg.addEventListener('mouseenter', this.svgMouseenterHandler);
    this.dom.bar.addEventListener('click', this.enableSurveyPanel);
    this.dom.closeSurvey.addEventListener('click', this.disableSurveyPanel);
  }

  /**
   * Remove event listeners
   */
  removeAllEventListeners() {
    window.addEventListener('scroll', this.scrollHandler);
    this.dom.svg.addEventListener('mouseenter', this.svgMouseenterHandler);
    this.dom.bar.addEventListener('click', this.enableSurveyPanel);
    this.dom.closeSurvey.addEventListener('click', this.disableSurveyPanel);
  }

  /**
   * Remove scroll Events
   */
  removeScrollEventListner() {
    window.removeEventListener('scroll', this.scrollHandler);
  }

  startHandler() {
    this.started = true;
    this.loop();
    window.removeEventListener('scroll', this.startHandler);
  }

  /**
   * Add timeouts to trigger animation if user does't scroll within spesified timeframe
   */
  timeChecks() {
    this.autoPlayAfterNoInteraction = window.setTimeout(() => {
      if (!this.hasStarted) {
        // console.log('autoPlayAfterNoInteraction');
        this.removeScrollEventListner();
        this.t.play();
        this.hasTimedOut = true;
      }
    }, 8000);

    this.showCTA = window.setTimeout(() => {
      this.enableBar();
    }, 3000);
  }

  /**
   * Callback for window scroll event.
   */
  scrollHandler() {
    TweenMax.to(this, 1.5, {
      // eslint-disable-line
      scrollProgress: window.scrollY, // eslint-disable-line
      ease: 'Linear.easeNone'

      // Start out loop when we first start scrolling
      //     if (!this.hasStarted && !this.hasCompleted && !this.hasTimedOut) {
      //       this.loop();
      //     }

      //     TweenMax.to(this, 5, { // eslint-disable-line
      //       scrollProgress: window.scrollY, // eslint-disable-line
      //       ease: ' Expo.easeOut', // eslint-disable-line,
      //       onComplete: () => {
      //         if (this.hasTimedOut) {
      //           this.t.play();
      //           this.removeScrollEventListner();
      //         }
      //       }
    });

    // Kill any auto play timeouts
    if (this.autoPlayAfterInteractionPause) {
      clearTimeout(this.autoPlayAfterInteractionPause);
    }

    // Create auto play timeout
    this.autoPlayAfterInteractionPause = window.setTimeout(() => {
      this.hasTimedOut = true;
    }, 3000);
  }

  /**
   * Request Animation Frame recursive loop
   */
  loop() {
    this.render();
    if (!this.hasTimedOut) {
      requestAnimationFrame(this.loop.bind(this));
    }
  }

  /**
   * Prepare any dom elements outside of the SVG
   */
  prepareDom() {
    this.dom.navExtras.style.transition =
      'opacity 0.76s cubic-bezier(0.645, 0.045, 0.355, 1)';

    if (!matchMediaDesktop()) {
      this.dom.pageHeader.style.position = 'fixed';
    }

    document.body.style.transition = 'padding 0.2s ease';
    document.body.style.paddingTop = `${this.dom.pageHeader.clientHeight}px`;
  }

  /**
   * Calculate letter spesific values and create per letter animations
   */
  prepareLetters() {
    Object.entries(this.letters).forEach(([letter, letterObj], index) => {
      // console.log(`${index}: ${letter} = ${letterObj}`)
      letterObj.letter = letter // eslint-disable-line
      letterObj.bbox = letterObj.path.getBBox() // eslint-disable-line

      letterObj.center = { // eslint-disable-line
        x: letterObj.bbox.x - letterObj.bbox.width / 2,
        y: letterObj.bbox.y - letterObj.bbox.height / 2
      };

      letterObj.scaleFactor = this.getRandomNumber(10, 40) / 10  // eslint-disable-line

      letterObj.explodedCenter = {  // eslint-disable-line
        x:
          index * this.explodedStep -
          this.letters.f.bbox.x +
          this.containerPadding,
        y: index % 2 === 0 ? letterObj.bbox.height : -letterObj.bbox.height
      };

      this.createLetterAnimation(letterObj);
    });
  }

  /**
   * Add letter spesific tweens to main Timlineline
   */
  createLetterAnimation(letterObj) {
    this.t

      // Explode
      .to(
        letterObj.path,
        this.duration,
        {
          x: letterObj.explodedCenter.x,
          y: letterObj.explodedCenter.y,
          scale: letterObj.scaleFactor,
          ease: 'Expo.easeOut', // eslint-disable-line
        },
        0
      )
      // Implode
      .to(
        letterObj.path,
        this.duration,
        {
          x: -145,
          y: 0,
          scale: 1,
          ease: 'Expo.easeInOut', // eslint-disable-line
        },
        1
      )
      // Explode
      .to(
        letterObj.path,
        this.duration,
        {
          x: letterObj.explodedCenter.x,
          y: letterObj.explodedCenter.y,
          scale: letterObj.scaleFactor,  // eslint-disable-line
          ease: 'Expo.easeInOut'
        },
        3.2
      )
      // Implode
      .to(
        letterObj.path,
        this.duration,
        {
          x: 0,
          y: 0,
          scale: 1,
          ease: 'Expo.easeInOut', // eslint-disable-line
        },
        4.2
      );

    // Add blur
    if (matchMediaDesktop() && !this.isSafari) {
				this.t.to("#fc-gaussian-blur-" + letterObj.letter, this.duration, { // eslint-disable-line
            attr: {
						stdDeviation: Math.min(Math.pow(letterObj.scaleFactor, letterObj.scaleFactor), 10) // eslint-disable-line
            },
					  ease: 'Expo.easeOut', // eslint-disable-line
          },
          0
        )
				.to("#fc-gaussian-blur-" + letterObj.letter, this.duration, { // eslint-disable-line
            attr: {
              stdDeviation: 0
            },
					ease: 'Expo.easeInOut', // eslint-disable-line
          },
          1
        )
				.to("#fc-gaussian-blur-" + letterObj.letter, this.duration, {  // eslint-disable-line
            attr: {
						stdDeviation: Math.min(Math.pow(letterObj.scaleFactor, letterObj.scaleFactor), 10) // eslint-disable-line
            },
					ease: 'Expo.easeInOut', // eslint-disable-line
          },
          3.2
        )
				.to("#fc-gaussian-blur-" + letterObj.letter, this.duration, { // eslint-disable-line
            attr: {
              stdDeviation: 0
            },
					ease: 'Expo.easeInOut', // eslint-disable-line
          },
          4.2
        );
    }
  }

  /**
   * Create SAP logo animation
   */
  createSapAnimation() {
    this.t

      // Reveal
      .to(
        this.dom.sapMask,
        this.duration,
        {
          attr: {
            x: 0
          },
        ease: 'Expo.easeInOut', // eslint-disable-line
        },
        1
      )
      .to(
        this.dom.sapLogo,
        this.duration,
        {
          x: 1540,
        ease: 'Expo.easeInOut', // eslint-disable-line
        },
        1
      )

      // Hide
      .to(
        this.dom.sapMask,
        this.duration,
        {
          attr: {
            x: 1660
          },
        ease: 'Expo.easeInOut', // eslint-disable-line
        },
        2.8
      )
      .to(
        this.dom.sapLogo,
        this.duration,
        {
          x: 1700,
        ease: 'Expo.easeInOut', // eslint-disable-line
        },
        2.8
      );
  }

  /**
   * Request animation frame callback
   */
  render() {
    // console.log(this.getScrollProgress());
    if (this.hasTimedOut) {
      return;
    }

    this.t
      .tweenTo(this.t.duration() * this.getScrollProgress(), {
        easing: 'Linear.easeNone',
        onComplete: () => {
          if (this.hasTimedOut) {
            this.t.play();
            this.removeScrollEventListner();
          }
        }
      }).duration(0.1); // eslint-disable-line
  }

  /**
   * Main timeline onStart callback
   */
  onStart() {
    this.hasStarted = true;
    this.disableNavExtras();
  }

  /**
   * Main timeline onComplete callback
   */
  onComplete() {
    this.hasCompleted = true;
    this.enableNavExtras();
    this.removeAllFilters();
    this.removeScrollEventListner();

    // Enable top bar
    window.setTimeout(() => {
      this.enableBar();

      // Update body padding on mobile
      if (!matchMediaDesktop()) {
        window.setTimeout(() => {
          document.body.style.paddingTop = `${
            this.dom.pageHeader.clientHeight
          }px`;
        }, 200);
      }
    }, 500);
  }

  /**
   * Enable Survey Panel
   */
  enableSurveyPanel() {
    this.hasSurveyPanel = true;
    this.dom.survey.classList.add('is-active');
    // console.log('enableSurveyPanel');
    this.disableBar();
    this.handleExpandSapSurveyTracking();
    window.setTimeout(() => {
      this.dom.survey.classList.add('allow-scroll');
    }, 300);
  }

  /**
   * Disable Survey Panel
   */
  disableSurveyPanel() {
    this.hasSurveyPanel = false;

    this.dom.survey.classList.remove('is-active');
    this.dom.survey.classList.remove('allow-scroll');
    this.enableBar();
    // console.log('disableSurveyPanel');
    this.handleCloseSapSurveyTracking();
  }

  /**
   * Enable top bar
   */
  enableBar() {
    if (this.hasBar || this.hasSurveyPanel) {
      return;
    }
    this.hasBar = true;
    this.dom.bar.classList.add('is-active');
  }

  /**
   * disable top bar
   */
  disableBar() {
    if (!this.hasBar) {
      return;
    }
    this.hasBar = false;
    this.dom.bar.classList.remove('is-active');
  }

  svgMouseenterHandler() {
    this.enableBar();
  }

  /**
   * Disable nav extra elements
   */
  disableNavExtras() {
    this.dom.navExtras.style.opacity = 0;
    this.dom.navExtras.style.pointeEvents = 'none';
  }

  /**
   * enable nav extra elements
   */
  enableNavExtras() {
    this.dom.navExtras.style.opacity = 1;
    this.dom.navExtras.style.pointeEvents = 'auto';
  }

  /**
   * Remove the SVG filters from each letter
   */
  removeAllFilters() {
    Object.entries(this.letters).forEach(([letter, letterObj], index) => { // eslint-disable-line
      letterObj.path.parentNode.removeAttribute('filter');
      // console.log(letterObj.path.parentNode)
    });
  }

  /**
   * Get the scroll progress as percentage. Percentage is expressed as a decimal between 0 - 1
   *
   * @return  {Number}  The current scroll progress
   */
  getScrollProgress() {
    // console.log(this.scrollProgress / this.maxScroll);
    return this.scrollProgress / this.maxScroll;
  }

  /**
   * Helper to generate random numbers between explict min and max values
   *
   * @param   {Number}  min  Minimum number that can be returned
   * @param   {Number}  max  Maximum number that can be returned
   *
   * @return  {Number}       Randomly generated number
   */
  getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
